import { Component, OnInit, Inject, HostListener, ViewChild, ElementRef, DOCUMENT, ChangeDetectionStrategy } from '@angular/core';


@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContactComponent implements OnInit {
  status = false;
  
  constructor() { }
  
  
    ngOnInit() {
    
  }

}
